import { render, staticRenderFns } from "./ClientAddEditModal.vue?vue&type=template&id=503d1238"
import script from "./ClientAddEditModal.vue?vue&type=script&lang=js"
export * from "./ClientAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports